import { render, staticRenderFns } from "./FeatureDisabled.vue?vue&type=template&id=57b31cb8&scoped=true&"
import script from "./FeatureDisabled.vue?vue&type=script&lang=ts&"
export * from "./FeatureDisabled.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureDisabled.vue?vue&type=style&index=0&id=57b31cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b31cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
